<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">اسم المجموعة:</label>
          <div>{{ name }}</div>
        </div>
      </div>

      <div v-for="(permission, indx) in permissionsList" class="row" :key="indx">
        <div class="col-12 mb-3 pb-2 border-bottom">
          <label for="" class="form-label"><i class="fa-solid fa-angle-left"></i> {{ permission.title }} :</label>
          <div class="row">
            <div v-for="(val, key) in permission.permissions" :key="key" class="col">
              <div class="form-check">
                <i v-if="permissions.indexOf(key) != -1" class="fa-solid fa-square-check"></i>
                <label class="form-check-label" :for="`permission-check-${key}`">{{ val }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
export default {
  name: 'GroupsView',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    permissionsList: {
      type: Array,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      name: '',
      permissions: [],
    }
  },
  created(){
    if(this.dataRow){
      this.name = this.dataRow.name;
      this.permissions = this.dataRow.permissions;
    }
  }
}
</script>
